import {
  addDays,
  endOfMonth,
  endOfWeek,
  isBefore,
  isSameDay,
  isValid,
  isWithinInterval,
  parseISO,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

import { CalendarPickerDateRange } from './calendarPicker.types';

export const identity = <T>(x: T) => x;

export const chunks = <T>(array: readonly T[], size: number): T[][] => {
  return Array.from({ length: Math.ceil(array.length / size) }, (v, i) =>
    array.slice(i * size, i * size + size),
  );
};

export const combine = (...args: any[]): string => args.filter(identity).join(' ');

// Date
export const getDaysInMonth = (date: Date) => {
  const startWeek = startOfWeek(startOfMonth(date), { weekStartsOn: 1 });
  const endWeek = endOfWeek(endOfMonth(date), { weekStartsOn: 1 });
  const days = [];
  for (let curr = startWeek; isBefore(curr, endWeek); ) {
    days.push(curr);
    curr = addDays(curr, 1);
  }
  return days;
};

export const isStartOfRange = ({ startDate }: CalendarPickerDateRange, day: Date) =>
  (startDate && isSameDay(day, startDate)) as boolean;

export const isEndOfRange = ({ endDate }: CalendarPickerDateRange, day: Date) =>
  (endDate && isSameDay(day, endDate)) as boolean;

export const inDateRange = ({ startDate, endDate }: CalendarPickerDateRange, day: Date) =>
  (startDate &&
    endDate &&
    (isWithinInterval(day, { start: startDate, end: endDate }) ||
      isSameDay(day, startDate) ||
      isSameDay(day, endDate))) as boolean;

export const isRangeSameDay = ({ startDate, endDate }: CalendarPickerDateRange) => {
  if (startDate && endDate) {
    return isSameDay(startDate, endDate);
  }
  return false;
};

type Falsy = false | null | undefined | 0 | '';

export const parseOptionalDate = (date: Date | string | Falsy, defaultValue: Date) => {
  if (typeof date === 'string') {
    const parsed = parseISO(date);

    if (isValid(parsed)) return parsed;
  } else if (date instanceof Date) {
    return date;
  }

  return defaultValue;
};
